
import { useState } from 'react';
import { useLanguage } from '@/hooks/use-language';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const WelcomeDialog = () => {
  const { t, showWelcomeDialog, setShowWelcomeDialog, showLanguageDialog } = useLanguage();
  const [currentPage, setCurrentPage] = useState(1);

  const handleClose = () => {
    localStorage.setItem('has-seen-welcome', 'true');
    setShowWelcomeDialog(false);
    setCurrentPage(1);
  };

  const handleNext = () => {
    setCurrentPage(2);
  };

  // Don't show welcome dialog while language dialog is still open
  const isOpen = showWelcomeDialog && !showLanguageDialog;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      if (!open) handleClose();
    }}>
      <DialogContent className="sm:max-w-[500px] bg-gradient-to-b from-white to-blue-50 max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold text-primary text-center mb-4">
            {t.dialog.welcome.title}
          </DialogTitle>
        </DialogHeader>
        
        <div 
          key={currentPage} 
          className="animate-fade-in"
        >
          {currentPage === 1 ? (
            <>
              <DialogDescription className="text-lg text-center leading-relaxed">
                {t.dialog.welcome.message}
              </DialogDescription>
              <DialogFooter className="mt-6 flex justify-center">
                <Button 
                  onClick={handleNext}
                  className="px-6 py-2 text-lg bg-primary hover:bg-primary/90 transition-all"
                >
                  {t.dialog.welcome.next} <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </DialogFooter>
            </>
          ) : (
            <>
              <DialogDescription className="text-lg text-center leading-relaxed">
                {t.dialog.welcome.message2}
              </DialogDescription>
              <DialogFooter className="mt-6 flex justify-center">
                <Button 
                  onClick={handleClose}
                  className="px-6 py-2 text-lg bg-primary hover:bg-primary/90 transition-all"
                >
                  {t.dialog.welcome.button}
                </Button>
              </DialogFooter>
            </>
          )}
        </div>

        {/* Page indicator */}
        <div className="flex justify-center gap-2 mt-2">
          <div className={`w-2 h-2 rounded-full transition-colors ${currentPage === 1 ? 'bg-primary' : 'bg-muted'}`} />
          <div className={`w-2 h-2 rounded-full transition-colors ${currentPage === 2 ? 'bg-primary' : 'bg-muted'}`} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeDialog;
